import React, { useState } from 'react'

import { CheckBox } from '../CheckBox'

import { CheckboxContainer, Container, LabelGroup, ValidationInput } from './CheckboxGroup.styled'

interface CheckboxOption {
  id: string
  label: string
  value: string
}

interface CheckboxGroupProps {
  options: CheckboxOption[]
  defaultValues?: string[]
  name?: string
  onChange?: (values: string[]) => void
  label?: string
  required?: boolean
  disabled?: boolean
}

export const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
  options,
  label,
  defaultValues = [],
  required = false,
  disabled = false,
  name = 'checkbox-group',
  onChange,
}) => {
  const [selectedValues, setSelectedValues] = useState<string[]>(defaultValues || [])
  const [touched, setTouched] = useState<boolean>(false)

  const hasNoSelection = selectedValues.length === 0

  const handleChange = (value: string) => {
    const newValues = selectedValues.includes(value)
      ? selectedValues.filter((v) => v !== value)
      : [...selectedValues, value]

    setSelectedValues(newValues)
    setTouched(true)
    onChange?.(newValues)
  }

  const handleBlur = () => {
    setTouched(true)
  }

  return (
    <Container>
      {label && <LabelGroup>{label}</LabelGroup>}
      <CheckboxContainer role="group" aria-required={required} onBlur={handleBlur}>
        {required && (
          <ValidationInput
            value={selectedValues.length > 0 ? selectedValues.join(',') : ''}
            onChange={() => {}}
            required={required}
            aria-hidden="true"
            aria-invalid={true}
          />
        )}
        {options.map(({ value, label, id }: CheckboxOption) => (
          <CheckBox
            key={id}
            id={id}
            name={name}
            label={label}
            checked={selectedValues.includes(value)}
            onChange={() => handleChange(value)}
            disabled={disabled}
            aria-invalid={touched && required && hasNoSelection}
          />
        ))}
      </CheckboxContainer>
    </Container>
  )
}
